import { Title } from '~/components/Title'
import { Input } from '~/components/Input'

export const Consent = () => {
  return (
    <>
      <Title content="Consent" />
      <div className="my-10 text-justify leading-loose print:my-2">
        Once signed by you, this form constitutes a legally valid decision record regarding ‘consent
        by person for use of body after death’ in accordance with s.4 of the Human Tissue Gift Act
        (British Columbia). The personal information you provide on this form is collected by BC
        Transplant, a part of the Provincial Health Services Authority, for the purpose of recording
        your decision regarding organ and tissue donation. It may be further used and disclosed in
        accordance with the Freedom of Information and Protection of Privacy Act (British Columbia)
        (“FIPPA”) for purposes consistent with its collection or as otherwise required by law. Under
        FIPPA you are entitled to access and correct any of your personal information that is within
        our custody and control.
      </div>
      <div className="mt-10 flex flex-wrap">
        <Input name="signerFirstName" label="Signer's First Name" />
        <Input name="signerLastName" label="Signer's Last Name" />
        <span className="ml-2">For someone under the age of 19, this record reflects an expressed wish about organ donation and is not a legally binding decision record, per the Human Tissue Gift Act.</span>
      </div>
    </>
  )
}
